var App = App || {};

App.SharedVideo = (function () {
    'use strict';

    const youtubeStringIdentifier = "youtube";
    const vimeoStringIdentifier = "vimeo";

    /* =========================================================================
    Initialization
    ========================================================================= */

    // Initializes video event bindings for a specific video element by ID
    const initializeVideos = videoId => {
        const videoElement = document.getElementById(videoId);
        if (!videoElement) return;
        bindVideoClick(videoElement);
        bindVideoModalClose(videoElement);
    };

    /* =========================================================================
    Event Binding
    ========================================================================= */

    // Binds the click event to the video button to trigger playback
    const bindVideoClick = videoElement => {
        const videoButtonElement = getVideoButtonElement(videoElement);
        if (!videoButtonElement) return;
        videoButtonElement.addEventListener("click", () => {
            playVideo(videoElement);
        });
    };

    // Binds the modal close event to stop video playback when the modal is hidden
    const bindVideoModalClose = videoElement => {
        const modalElement = videoElement.closest(".modal");
        if (!modalElement) return;
        modalElement.addEventListener('hidden.bs.modal', () => {
            stopVideo(videoElement);
        });
    };

    /* =========================================================================
    UI Synchronization
    ========================================================================= */

    let currentlyPlayingVideo = null;

    // Handles playing a video, ensuring only one video plays at a time
    const playVideo = videoElement => {
        if (!videoElement) return;

        const videoButtonElement = getVideoButtonElement(videoElement);
        if (!videoButtonElement) return;

        const videoPlaceholderElement = getVideoPlaceholderElement(videoElement);
        if (!videoPlaceholderElement) return;

        const videoSourceString = videoButtonElement.getAttribute("data-src");
        if (!videoSourceString) {
            console.log("No video source found");
            return;
        }

        const videoTitleString = videoButtonElement.getAttribute("data-title");

        // Stop the previously playing video if it exists and is not the current one
        if (currentlyPlayingVideo && currentlyPlayingVideo !== videoElement) {
            stopVideo(currentlyPlayingVideo);
        }
        currentlyPlayingVideo = videoElement;

        const sourceLower = videoSourceString.toLowerCase();
        let iframeHtml = null;

        if (sourceLower.includes(youtubeStringIdentifier)) {
            iframeHtml = standardizeYoutubeIframe(videoSourceString, videoTitleString);
        }
        else if (sourceLower.includes(vimeoStringIdentifier)) {
            iframeHtml = standardizeVimeoIframe(videoSourceString, videoTitleString);
        }

        if (iframeHtml) {
            videoPlaceholderElement.innerHTML = iframeHtml;
            videoButtonElement.style.display = 'none';
            videoPlaceholderElement.style.display = 'block';
        }
        else {
            console.log("Could not locate video content");
        }
    };

    // Stops video playback and resets the UI for the given video element
    const stopVideo = videoElement => {
        if (!videoElement) return;
        const videoPlaceholderElement = getVideoPlaceholderElement(videoElement);
        if (videoPlaceholderElement) {
            videoPlaceholderElement.style.display = 'none';
            videoPlaceholderElement.innerHTML = '';
        }
        const videoButtonElement = getVideoButtonElement(videoElement);
        if (videoButtonElement) {
            videoButtonElement.style.display = 'block';
        }
        if (currentlyPlayingVideo === videoElement) {
            currentlyPlayingVideo = null;
        }
    };

    // Returns a YouTube iframe HTML string for embedding
    const standardizeYoutubeIframe = (videoSrc, videoTitle) => `
        <iframe
            src="${videoSrc}"
            title="${videoTitle}"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
        </iframe>
    `;

    // Returns a Vimeo iframe HTML string for embedding
    const standardizeVimeoIframe = (videoSrc, videoTitle) => `
        <iframe
            src="${videoSrc}"
            title="${videoTitle}"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen>
        </iframe>
    `;

    /* =========================================================================
    Helpers
    ========================================================================= */

    // Returns the video placeholder element for the given video element
    const getVideoPlaceholderElement = videoElement =>
        videoElement.querySelector(".partial-video__placeholder");

    // Returns the video button element for the given video element
    const getVideoButtonElement = videoElement =>
        videoElement.querySelector(".partial-video__button");

    /* =========================================================================
    Public API Exposure
    ========================================================================= */

    return {
        initializeVideos
    };

})();
